export enum PermissionType {
    EDIT_GENERAL_AVAILABILITY = 'edit_general_availability',
    ADD_AVAILABILITY_DAYS = 'add_availability_days',
    REMOVE_AVAILABILITY_DAYS = 'remove_availability_days',
    VIEW_ESTIMATED_WORK_HOURS = 'view_estimated_work_hours',
}
